import { Leave } from './show-leave'
import { Compensate } from './show-compensate'

export {
  Leave,
  Compensate,
}



// WEBPACK FOOTER //
// ./src/components/leave-request/index.js